<template>
  <section class="footer">
    <div class="item">
      <a href="https://m.suhuishou.com">卖手机</a>
    </div>
    <div class="item active">
      <span>换新机</span>
    </div>
    <div class="item">
      <a href="https://m.suhuishou.com/user">我的</a>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
  height: 0.5rem;
  background: #fff;
  box-shadow: 0px 0px 0.04rem 0px rgba(134, 130, 130, 0.3);
  border-radius: 0.05rem;
  display: flex;
  flex-flow: wrap;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
}
.footer .item {
  width: 33.33%;
  text-align: center;
  padding: 0.06rem 0 0;
}
.footer .item:before {
  display: inline-block;
  content: "";
  width: 0.25rem;
  height: 0.25rem;
  background: url(../../../assets/image/footer_bg.png) 0 -0.28rem no-repeat;
  background-size: 0.85rem;
}
.footer .item:nth-child(2)::before {
  background-position: -0.28rem -0.28rem;
}
.footer .item:nth-child(3)::before {
  background-position: -0.56rem -0.28rem;
}
.footer .item.active span {
  color: #f9415d;
}
.footer .item.active:nth-child(2)::before {
  background-position: -0.28rem 0rem;
}
.footer .item a,
.footer .item span {
  display: block;
  color: #ababab;
  font-size: 0.12rem;
}
</style>
